import { createSlice } from "@reduxjs/toolkit";
import { getDashCount } from "../thunks/dashboardThunk";

const initialState = {
  isDashLoading: false,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDashCount.pending, (state) => {
        state.isDashLoading = true;
      })
      .addCase(getDashCount.fulfilled, (state, action) => {
        ((state.isDashLoading = false), (state.action = action.payload));
      })
      .addCase(getDashCount.rejected, (state) => {
        state.isDashLoading = false;
      });
  },
});

export default dashboardSlice.reducer;
